module.exports = __webpack_public_path__ + "img/one_3.bb1806bd.png";